/**
 * Whether the compact composer is on screen (⌘J, RFC 0336 3c).
 *
 * Shown always, unless it has been put out of the way: by ⌘J, or by a
 * layout that floats it. Out of the way, the bottom edge brings it up, as
 * the sidebar's left edge does. Three things bring it up regardless, because
 * hiding them would hide something you are in the middle of: the box has
 * focus (you are typing), or a session is asking you a question, which the
 * composer is where you answer. The World view (⌘.) draws in its own place
 * and opens whatever this says.
 */
export function composerShows(state: {
  /** Put out of the way: ⌘J, or a layout that floats the composer. */
  floats: boolean
  /** The pointer reached the bottom edge. */
  revealed: boolean
  /** Focus is inside the composer. */
  focused: boolean
  /** A session is waiting on your answer. */
  asking: boolean
}): boolean {
  return !state.floats || state.revealed || state.focused || state.asking
}
